import ButtonPrimary from "shared/Button/ButtonPrimary";
import Hours from "./icon";
import { useHotels } from "contexts/HotelsSearchContext/HotelProvider";
import { LocalStorageRecentSearches } from "components/HeroSearchFormSmall/LocationInput";
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from "react";
import { useMetadataUser } from "contexts/metadata-user-context";
import { Formatter } from "utils/formatters";

type ModalTokenExpirationData = {
    destinationName: string | undefined;
    checkInDate: string | undefined;
    destination: number | undefined;
    numNights: number | undefined;
    adults: number | undefined;
    children: number | undefined;
    agesChildren: number[] | undefined;
};

type ModalTokenExpirationProps = {
    setOpenModal: (value: boolean) => void;
    openModal: boolean;
    data: ModalTokenExpirationData;
};

export function ModalTokenExpiration({ setOpenModal, openModal, data }: Readonly<ModalTokenExpirationProps>) {
    const { profile } = useMetadataUser();
    const [checkInDateHome, setCheckInDateHome] = useState<string | undefined>();
    const {
        searchHotels,
        setPageReload,
        setHotelSearchFirst,
        setHiddenHero,
        checkInDate,
        guests,
        getHotelSearchFirst,
        setCheckInDate,
        setDestination,
        setNumNights,
        setGuests,
        setDestinationName,
        destinationName,
        destination,
        numNights,
    } = useHotels();
    const location = useLocation();
    const navigate = useNavigate();

    const storedDestinationsString = localStorage.getItem(
        "recentSearchesDestinations"
    );
    const storedDestinations: LocalStorageRecentSearches[] = storedDestinationsString
        ? JSON.parse(storedDestinationsString)
        : [];

    useEffect(() => {
        if (profile) {
            const blockedUntil = profile?.subscription?.blocked_until;
            const company = profile?.company;
            const stateCheckInDate = new Date(checkInDate);
            const blockedUntilDate = blockedUntil ? new Date(blockedUntil) : null;

            if (blockedUntilDate && !company && stateCheckInDate < blockedUntilDate) {
                const setDate1Days = new Date(blockedUntil ?? "");
                setDate1Days.setDate(setDate1Days.getDate() + 2);
                setCheckInDateHome(Formatter.prettyDateHifen(setDate1Days));
                setCheckInDate(Formatter.prettyDateHifen(setDate1Days));
            } else {
                setCheckInDateHome(checkInDate);
            }
        }
    }, []);

    useEffect(() => {
        console.log(destination)
        if (data.destinationName) {
            setDestinationName(data.destinationName);
        }
        if (data.checkInDate) {
            setCheckInDate(data.checkInDate);
        }
        if (data.destination) {
            setDestination(data.destination);
        }
        if (data.numNights) {
            setNumNights(data.numNights);
        }
        if (data.destinationName === undefined) {
            setDestinationName(destinationName);
        }
        if (data.checkInDate === undefined) {
            setCheckInDate(checkInDate);
        }
        if (data.destination === undefined) {
            setDestination(destination);
        }
        if (data.numNights === undefined) {
            setNumNights(numNights);
        }

        setGuests({
            adults: data.adults ? data.adults : guests.adults,
            children: data.children ? data.children : guests.children,
            agesChildren: data.agesChildren ? data.agesChildren : guests.agesChildren,
        });
    }, [
        setCheckInDate,
        setDestination,
        setNumNights,
        setGuests,
        setDestinationName,
    ]);


    return (
        <div className="min-h-screen w-full fixed left-0 top-0 flex justify-center items-center bg-black/70 z-50 transition-all duration-500 ease-in-out">
            <div className="w-[21rem] h-[14rem] flex flex-col items-center bg-white p-4 rounded-2xl shadow-2xl">
                <h2 className="text-neutral-900 font-bold text-xl">
                    Atualize sua pesquisa
                </h2>
                <div className="flex justify-between items-center w-full gap-2 my-4">
                    <p className="text-neutral-900">
                        As disponibilidades e preços podem ter mudado.
                    </p>
                    <Hours />
                </div>
                <ButtonPrimary
                    className="bg-[#4F46E5]"
                    onClick={() => {
                        if (location.pathname !== "/home") {
                            navigate("/home");
                            setOpenModal(!openModal);
                            setHiddenHero(false);
                            setPageReload(true);
                        } else {
                            setOpenModal(!openModal);
                        }
                        searchHotels({
                            destination: data.destination ? data.destination : destination,
                            numNights: data.numNights ? data.numNights : numNights,
                            checkInDate: data.checkInDate ? data.checkInDate : checkInDateHome,
                            guests: {
                                adults: data.adults ? data.adults : guests.adults,
                                children: data.children ? data.children : guests.children,
                                agesChildren: data.agesChildren ? data.agesChildren : guests.agesChildren,
                            }
                        }).finally(() => {
                            const hotelSearchFirst = storedDestinations.find(
                                (item) => item.type === "HOTEL"
                            );
                            if (hotelSearchFirst) {
                                setHotelSearchFirst(getHotelSearchFirst);
                            } else {
                                setHotelSearchFirst(null);
                            }
                        });
                    }}
                >
                    Atualizar resultados
                </ButtonPrimary>
            </div>
        </div>
    )
}
